/** 连续加权采样：保留跨块的小数相位，44.1k/48k 音频均转换成 16k 单声道 PCM。 */
export class PcmResampler {
  private weight = 0;
  private sum = 0;
  private readonly ratio: number;
  constructor(sampleRate: number) {
    if (!Number.isFinite(sampleRate) || sampleRate < 16000) throw new Error('麦克风采样率不支持');
    this.ratio = sampleRate / 16000;
  }
  process(input: Float32Array): number[] {
    const output: number[] = [];
    for (const sample of input) {
      let remaining = 1;
      while (remaining > 1e-9) {
        const take = Math.min(remaining, this.ratio - this.weight);
        this.sum += Math.max(-1, Math.min(1, sample)) * take;
        this.weight += take;
        remaining -= take;
        if (this.weight >= this.ratio - 1e-9) {
          output.push(Math.round(Math.max(-32768, Math.min(32767, this.sum / this.ratio * 32768))));
          this.sum = this.weight = 0;
        }
      }
    }
    return output;
  }
}
